import { configureStore, getDefaultMiddleware, ThunkAction, Action } from '@reduxjs/toolkit';
import { createLogger } from 'redux-logger';
// eslint-disable-next-line import/no-cycle
import sectionsReducer from './reducers/sections';
// eslint-disable-next-line import/no-cycle
import userDataReducer from './reducers/userData';
// eslint-disable-next-line import/no-cycle
import quizReducer from './reducers/quiz';

const logger = createLogger({
  collapsed: true,
});

const middleware = [...getDefaultMiddleware(), logger];

export const store = configureStore({
  reducer: {
    sections: sectionsReducer,
    userData: userDataReducer,
    quiz: quizReducer,
  },
  middleware,
  devTools: process.env.NODE_ENV !== 'production',
});

export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<ReturnType, RootState, unknown, Action<string>>;
